const jobs = [
  {
    id: 1,
    title: "Sales Development Representative",
    department: "Sales",
    location: "Chennai, India",
    type: "Full-time",
    mode: "On-site",
    experience: "0–2 Years",
    salary: "₹5L – ₹9L + Incentives",
    posted: "1 day ago",
    urgent: true,
    color: "#10b981",
    description:
      "Be the first point of contact for OruClick's prospects. Generate qualified opportunities and fuel our high-growth sales engine across India's SMB market.",
    responsibilities: [
      "Prospect and qualify inbound and outbound leads daily",
      "Conduct discovery calls and product demos for SMB clients",
      "Maintain accurate and up-to-date CRM records",
      "Meet and exceed monthly pipeline and revenue targets",
      "Collaborate with Account Executives to hand off qualified deals",
    ],
    requirements: [
      "0–2 years of sales or customer-facing experience",
      "Excellent verbal and written communication in English",
      "Resilient, self-motivated and target-driven mindset",
      "Comfortable working with CRM tools",
      "Fluency in Tamil and/or Hindi is a strong plus",
    ],
    niceToHave: [
      "Prior B2B SaaS sales experience",
      "Understanding of the SMB landscape in India",
      "Experience with outreach tools like Apollo or Outreach",
    ],
  },
  {
    id: 2,
    title: "Account Executive — Mid Market",
    department: "Sales",
    location: "Bangalore, India",
    type: "Full-time",
    mode: "Hybrid",
    experience: "3–5 Years",
    salary: "₹12L – ₹22L + Commission",
    posted: "2 days ago",
    urgent: true,
    color: "#0ea5e9",
    description:
      "Own the full sales cycle for mid-market accounts. Build lasting relationships, deliver tailored demos, and close deals that drive meaningful revenue for OruClick.",
    responsibilities: [
      "Manage a pipeline of 50–80 mid-market prospects at any time",
      "Deliver compelling product demos and handle objections confidently",
      "Negotiate and close contracts ranging ₹5L–₹50L ARR",
      "Collaborate with Customer Success for smooth onboarding handoffs",
      "Provide accurate weekly forecasts to sales leadership",
    ],
    requirements: [
      "3+ years of B2B SaaS sales or account management experience",
      "Proven track record of meeting or exceeding quota",
      "Strong negotiation and relationship-building skills",
      "Experience managing multi-stakeholder deal cycles",
      "Proficient with CRM tools (Salesforce, HubSpot, or similar)",
    ],
    niceToHave: [
      "Experience selling CRM or MarTech solutions",
      "Network in the Indian SME/mid-market segment",
      "Familiarity with MEDDIC or SPIN selling methodologies",
    ],
  },
  {
    id: 3,
    title: "Enterprise Account Executive",
    department: "Sales",
    location: "Mumbai, India",
    type: "Full-time",
    mode: "Hybrid",
    experience: "5–8 Years",
    salary: "₹25L – ₹40L + Commission",
    posted: "3 days ago",
    urgent: true,
    color: "#6366f1",
    description:
      "Land and expand enterprise accounts across India's top 500 companies. Lead high-stakes negotiations and become a trusted advisor to CXO-level stakeholders.",
    responsibilities: [
      "Build and manage a pipeline of enterprise-level opportunities",
      "Drive complex, multi-stakeholder sales cycles from discovery to close",
      "Develop executive-level relationships across prospect organisations",
      "Define and execute account-based sales strategies",
      "Collaborate with Pre-Sales, Customer Success, and Legal on large deals",
    ],
    requirements: [
      "5+ years of enterprise B2B sales experience",
      "Demonstrated success closing deals above ₹1Cr ARR",
      "Strong CXO-level communication and executive presence",
      "Experience with complex contract negotiations",
      "Track record of consistently exceeding quota",
    ],
    niceToHave: [
      "Experience selling SaaS to BFSI or manufacturing verticals",
      "MBA from a top-tier institution",
      "Existing CXO network in large Indian enterprises",
    ],
  },
  {
    id: 4,
    title: "Digital Marketing Manager",
    department: "Marketing",
    location: "Chennai, India",
    type: "Full-time",
    mode: "Hybrid",
    experience: "3–5 Years",
    salary: "₹10L – ₹18L",
    posted: "3 days ago",
    urgent: false,
    color: "#f59e0b",
    description:
      "Lead OruClick's digital presence across SEO, paid media, content, and social channels. Drive brand awareness and build a scalable demand-generation engine.",
    responsibilities: [
      "Plan and execute multi-channel digital marketing campaigns",
      "Own the SEO strategy and monthly content calendar",
      "Manage paid media budgets across Google, LinkedIn, and Meta",
      "Analyse campaign performance and continuously optimise for ROI",
      "Partner with Sales to align marketing efforts with pipeline goals",
    ],
    requirements: [
      "3+ years in digital marketing or growth marketing",
      "Hands-on experience running Google Ads and Meta Ads",
      "Strong SEO fundamentals and content marketing knowledge",
      "Proficiency in analytics tools — GA4, HubSpot, or similar",
      "Excellent copywriting and storytelling skills",
    ],
    niceToHave: [
      "Experience marketing a B2B SaaS product",
      "Video and visual content creation capabilities",
      "Knowledge of marketing automation platforms",
    ],
  },
  {
    id: 5,
    title: "Content Marketing Specialist",
    department: "Marketing",
    location: "Remote — India",
    type: "Full-time",
    mode: "Remote",
    experience: "2–4 Years",
    salary: "₹7L – ₹12L",
    posted: "4 days ago",
    urgent: false,
    color: "#f97316",
    description:
      "Create compelling content that educates, attracts, and converts OruClick's target audience. Own the blog, case studies, email newsletters, and social media content strategy.",
    responsibilities: [
      "Write and publish 8–10 high-quality blog articles per month",
      "Develop customer case studies and success stories",
      "Manage the weekly email newsletter with 20,000+ subscribers",
      "Create social media content across LinkedIn, Twitter, and Instagram",
      "Collaborate with SEO team to ensure all content is search-optimised",
    ],
    requirements: [
      "2+ years of content marketing or copywriting experience",
      "Exceptional English writing and editing skills",
      "Understanding of SEO content best practices",
      "Experience with CMS platforms (WordPress, Webflow, etc.)",
      "Ability to translate complex B2B concepts into engaging content",
    ],
    niceToHave: [
      "Prior experience writing for a SaaS or technology brand",
      "Familiarity with tools like Semrush, Ahrefs, or Clearscope",
      "Video scripting or podcast production experience",
    ],
  },
  {
    id: 6,
    title: "Performance Marketing Analyst",
    department: "Marketing",
    location: "Chennai, India",
    type: "Full-time",
    mode: "On-site",
    experience: "1–3 Years",
    salary: "₹6L – ₹11L",
    posted: "5 days ago",
    urgent: false,
    color: "#eab308",
    description:
      "Manage and optimise paid acquisition campaigns to drive qualified pipeline for OruClick. Own budget allocation, A/B testing, and performance reporting across all paid channels.",
    responsibilities: [
      "Execute and optimise campaigns across Google, LinkedIn, and Meta",
      "Conduct regular A/B tests on creatives, copy, and landing pages",
      "Build and maintain performance dashboards for marketing leadership",
      "Identify new paid channels and run experiments to grow traffic",
      "Work closely with the Content team on ad creatives and messaging",
    ],
    requirements: [
      "1–3 years hands-on paid media experience",
      "Google Ads & Meta Ads certified (or equivalent experience)",
      "Strong analytical skills with proficiency in Excel / Google Sheets",
      "Familiarity with conversion tracking and attribution models",
      "Detail-oriented with a data-first mindset",
    ],
    niceToHave: [
      "Experience with LinkedIn Ads for B2B demand generation",
      "Knowledge of marketing attribution tools (Rockerbox, TripleWhale)",
      "Basic SQL knowledge for querying campaign data",
    ],
  },
  {
    id: 7,
    title: "Customer Success Manager",
    department: "Operations",
    location: "Chennai, India",
    type: "Full-time",
    mode: "Hybrid",
    experience: "2–4 Years",
    salary: "₹8L – ₹15L",
    posted: "4 days ago",
    urgent: true,
    color: "#d946ef",
    description:
      "Be the trusted advisor for OruClick's growing customer base. Drive adoption, reduce churn, and turn satisfied customers into passionate brand advocates.",
    responsibilities: [
      "Own a portfolio of 40–60 business accounts post-onboarding",
      "Conduct regular health checks, QBRs, and check-in calls",
      "Identify upsell and expansion opportunities within accounts",
      "Act as the voice of the customer with Product and Sales teams",
      "Resolve escalations quickly and ensure high customer satisfaction",
    ],
    requirements: [
      "2+ years in customer success, account management, or support",
      "Exceptional interpersonal and relationship-building skills",
      "Strong problem-solving and empathy-first approach",
      "Comfortable using CRM and CS tools (Gainsight, ChurnZero, etc.)",
      "Data-driven with ability to track NPS, CSAT, and retention KPIs",
    ],
    niceToHave: [
      "Experience in B2B SaaS customer success",
      "Background in business consulting or client servicing",
      "Familiarity with CRM product categories",
    ],
  },
  {
    id: 8,
    title: "Operations Analyst",
    department: "Operations",
    location: "Chennai, India",
    type: "Full-time",
    mode: "On-site",
    experience: "1–3 Years",
    salary: "₹6L – ₹10L",
    posted: "6 days ago",
    urgent: false,
    color: "#8b5cf6",
    description:
      "Support OruClick's business operations by analysing processes, identifying inefficiencies, and implementing improvements that help our teams move faster and smarter.",
    responsibilities: [
      "Analyse business processes and identify areas for automation or improvement",
      "Build and maintain operational dashboards and reports",
      "Coordinate cross-functional projects between Sales, Marketing, and CS",
      "Support revenue operations including CRM hygiene and data audits",
      "Document SOPs and internal workflows for growing teams",
    ],
    requirements: [
      "1–3 years in business operations, analytics, or consulting",
      "Strong Excel / Google Sheets skills; SQL is a plus",
      "Excellent organisational and project management abilities",
      "Ability to communicate clearly with stakeholders at all levels",
      "Process-oriented with a bias for continuous improvement",
    ],
    niceToHave: [
      "Exposure to revenue operations or sales ops",
      "Experience with BI tools like Tableau or Looker",
      "Familiarity with CRM platforms and their data models",
    ],
  },
  {
    id: 9,
    title: "Business Development Manager",
    department: "Sales",
    location: "Mumbai, India",
    type: "Full-time",
    mode: "On-site",
    experience: "4–7 Years",
    salary: "₹15L – ₹25L + Incentives",
    posted: "5 days ago",
    urgent: false,
    color: "#ef4444",
    description:
      "Identify and unlock new business opportunities, strategic partnerships, and enterprise accounts to accelerate OruClick's expansion across new geographies and segments.",
    responsibilities: [
      "Develop and execute a strategic BD plan for new markets",
      "Identify and cultivate channel & reseller partnerships",
      "Lead enterprise-level negotiations and contract closures",
      "Represent OruClick at industry events and trade shows",
      "Work cross-functionally with Marketing, Product, and Leadership",
    ],
    requirements: [
      "4+ years in business development, partnerships, or enterprise sales",
      "Strong existing network in the Indian B2B market",
      "Exceptional communication, negotiation, and presentation skills",
      "Ability to work independently and manage complex deal structures",
      "Strategic thinker with a strong execution mindset",
    ],
    niceToHave: [
      "Experience in SaaS or technology partnerships",
      "Exposure to CRM, ERP, or business software markets",
      "MBA from a reputed institution",
    ],
  },
  {
    id: 10,
    title: "HR Business Partner",
    department: "HR",
    location: "Chennai, India",
    type: "Full-time",
    mode: "Hybrid",
    experience: "3–6 Years",
    salary: "₹8L – ₹14L",
    posted: "1 week ago",
    urgent: false,
    color: "#6366f1",
    description:
      "Partner with business leaders to build a high-performance culture at OruClick. Own talent acquisition, employee engagement, and people operations for your business unit.",
    responsibilities: [
      "Partner with department heads on hiring plans and workforce strategy",
      "Drive end-to-end recruitment for non-technical business roles",
      "Design and implement employee engagement and retention programmes",
      "Manage performance review cycles and career development frameworks",
      "Ensure HR policy compliance and handle employee relations matters",
    ],
    requirements: [
      "3+ years of HR generalist or HRBP experience",
      "Strong knowledge of Indian labour laws and compliance",
      "Excellent interpersonal and conflict-resolution skills",
      "Experience with HRMS platforms (Darwinbox, Zoho People, etc.)",
      "Data-driven with ability to report on HR metrics",
    ],
    niceToHave: [
      "Experience in a high-growth SaaS or startup environment",
      "HR certification (SHRM, CHRP, or equivalent)",
      "Background in talent development or L&D",
    ],
  },
  {
    id: 11,
    title: "Talent Acquisition Specialist",
    department: "HR",
    location: "Chennai, India / Remote",
    type: "Full-time",
    mode: "Remote",
    experience: "2–4 Years",
    salary: "₹6L – ₹11L",
    posted: "2 days ago",
    urgent: true,
    color: "#14b8a6",
    description:
      "Own end-to-end hiring for OruClick's fast-growing business teams. Build talent pipelines, deliver exceptional candidate experiences, and help us hire the best people in India.",
    responsibilities: [
      "Manage full-cycle recruitment for Sales, Marketing, CS, and Ops roles",
      "Source passive candidates via LinkedIn, job boards, and referral networks",
      "Coordinate and conduct structured interviews with hiring managers",
      "Maintain an organised ATS and ensure timely candidate communication",
      "Report on hiring metrics — time-to-fill, offer acceptance rate, source quality",
    ],
    requirements: [
      "2+ years of talent acquisition or recruiting experience",
      "Proven ability to close roles within tight timelines",
      "Experience with ATS platforms (Greenhouse, Lever, Keka, etc.)",
      "Strong communication and candidate management skills",
      "Ability to manage multiple open positions simultaneously",
    ],
    niceToHave: [
      "Experience hiring for B2B SaaS or startup environments",
      "Familiarity with employer branding strategies",
      "Background in non-technical business hiring (Sales, Marketing, Ops)",
    ],
  },
  {
    id: 12,
    title: "Finance & Revenue Analyst",
    department: "Operations",
    location: "Chennai, India",
    type: "Full-time",
    mode: "On-site",
    experience: "2–5 Years",
    salary: "₹8L – ₹15L",
    posted: "1 week ago",
    urgent: false,
    color: "#0284c7",
    description:
      "Support OruClick's financial planning, revenue reporting, and business analytics. Help leadership make informed decisions with sharp financial models and data-driven insights.",
    responsibilities: [
      "Own monthly revenue reporting, MRR/ARR tracking, and cohort analysis",
      "Build and maintain financial models for planning and forecasting",
      "Support the annual and quarterly budgeting process",
      "Analyse unit economics (CAC, LTV, payback period) and present insights",
      "Coordinate with Sales and CS on billing, invoicing, and collections",
    ],
    requirements: [
      "2+ years in finance, FP&A, or business analytics",
      "Strong Excel / Google Sheets financial modelling skills",
      "Understanding of SaaS revenue metrics and subscription economics",
      "High attention to detail and accuracy",
      "Strong communication skills to present data to non-finance stakeholders",
    ],
    niceToHave: [
      "CA / MBA Finance qualification",
      "Experience with tools like Stripe, Chargebee, or Razorpay",
      "Familiarity with BI tools such as Metabase or Looker",
    ],
  },
];

export default jobs;
